import { useState } from "react";
import { useToast } from "@/hooks/use-toast";

// TODO: Remove execCommand fallback once site is served over HTTPS.
// Currently using execCommand as a temporary solution until HTTPS is implemented.
export const useCopyToClipboard = () => {
  const [isCopied, setIsCopied] = useState(false);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const { toast } = useToast();

  const handleCopy = async (value: string) => {
    try {
      // Try modern clipboard API first
      if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
        await navigator.clipboard.writeText(value);
      } else {
        // Fallback to execCommand
        const textArea = document.createElement("textarea");
        textArea.value = value;
        textArea.style.position = "fixed";
        textArea.style.opacity = "0";

        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
      }

      setIsCopied(true);
      setIsTooltipOpen(true);

      const timeoutId = setTimeout(() => {
        setIsCopied(false);
        setIsTooltipOpen(false);
      }, 2000);

      return () => clearTimeout(timeoutId);
    } catch (err) {
      console.error("Failed to copy text:", err);
      toast({
        title: "Failed to copy",
        description: "Please try again",
        variant: "destructive",
        duration: 2000,
      });
    }
  };

  return {
    isCopied,
    isTooltipOpen,
    setIsTooltipOpen,
    handleCopy,
  };
};
